import React from 'react'
import get from 'lodash/get'
import OverquotaBanner, {
  isOverquota,
} from 'components/informers/overquota-banner'
import PaymentOverdueBanner from 'components/informers/payment-overdue'

import { CancelSubscriptionBanner } from 'components/common/subscribed-user-billing/cancel-subscription/CancelSubscriptionBanner'
import { useSelector } from 'react-redux'
import { getUser } from '@disco/state-management/selectors/user'
import { useCancellationBanner } from 'components/common/subscribed-user-billing/cancel-subscription/CancellationBannerProvider'
import { useSchoolOfDiscoBanner } from 'components/informers/school-of-disco-banner/use-school-of-disco-banner'

export function useBanners() {
  const user = useSelector(getUser)

  const { shouldShowBanner } = useCancellationBanner()
  const schoolOfDiscoBanner = useSchoolOfDiscoBanner()

  const paymentOverdue = get(
    user,
    'business.private_metadata.payment_overdue',
    false,
  )
  const paymentOverdueBankWire = get(
    user,
    'business.private_metadata.payment_overdue_bank_wire',
    false,
  )
  const overquotaInfo = isOverquota(user.business)

  let banners: { element: React.ReactNode; heightPx: number }[] = []

  if (paymentOverdueBankWire) {
    banners = banners.concat({
      element: <PaymentOverdueBanner messageId="OVERDUE_BANKWIRE" key="1" />,
      heightPx: 38,
    })
  } else if (paymentOverdue) {
    banners = banners.concat({
      element: <PaymentOverdueBanner messageId="OVERDUE_DEFAULT" key="1" />,
      heightPx: 38,
    })
  } else if (overquotaInfo) {
    banners = banners.concat({
      element: (
        <OverquotaBanner key="overquota" overquotaInfo={overquotaInfo} />
      ),
      heightPx: 38,
    })
  } else if (shouldShowBanner) {
    banners = banners.concat({
      element: <CancelSubscriptionBanner key="cancellation" />,
      heightPx: 38,
    })
  } else if (schoolOfDiscoBanner.bannerNode) {
    banners = banners.concat({
      element: schoolOfDiscoBanner.bannerNode,
      heightPx: schoolOfDiscoBanner.heightPx,
    })
  }

  return banners
}
